const ENV = import.meta.env.MODE || 'development';

interface Config {
  userServiceUrl: string;
  feedServiceUrl: string;
  env: string;
}

const configs: Record<string, Config> = {
  development: {
    userServiceUrl: 'http://localhost:8001/api/v1',
    feedServiceUrl: 'http://localhost:8000/api/v1',
    env: 'development',
  },
  staging: {
    userServiceUrl: 'https://user-service-production-65af.up.railway.app/api/v1',
    feedServiceUrl: 'https://feed-flow-backend-production.up.railway.app/api/v1',
    env: 'staging',
  },
  production: {
    userServiceUrl: 'https://user-service-production-65af.up.railway.app/api/v1',
    feedServiceUrl: 'https://feed-flow-backend-production.up.railway.app/api/v1',
    env: 'production',
  },
};

export const config = configs[ENV] || configs.development;

export default config;
